module.exports = __webpack_public_path__ + "img/iphone-charging-SPAIN-en.577c23c2.png";